export default __webpack_public_path__ + "static/media/IMG_8414.14929fcc.jpeg";